import { render, staticRenderFns } from "./ContractRegisterHtmlComponent.vue?vue&type=template&id=a8b3a7ee&scoped=true&"
import script from "./ContractRegisterHtmlComponent.vue?vue&type=script&lang=js&"
export * from "./ContractRegisterHtmlComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContractRegisterHtmlComponent.vue?vue&type=style&index=0&id=a8b3a7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b3a7ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
